module.exports = fox._r("components/valentines-gifts-popup/images/gifts-bg.png", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/images/gifts-bg.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/images/gifts-bg.png
// module id = 727
// module chunks = 4